import { useCallback } from "react";
import { useLiveDashboardStats } from "../../../global/hooks/useLiveDashboardStats";
import { getVisitorDashboard } from "../api/dashboardApi";
import { VISITOR_DATA_CHANGED_EVENT } from "./visitorDataEvents";

/** Visitor summary cards with live refresh (poll, focus, after list mutations). */
export function useVisitorDashboardStats({
  enabled = true,
  reloadToken = 0,
  listScope = "self",
} = {}) {
  const fetcher = useCallback(() => getVisitorDashboard({ scope: listScope }), [listScope]);
  const selectData = useCallback((response) => response?.data ?? null, []);

  return useLiveDashboardStats({
    fetcher,
    enabled,
    selectData,
    refreshDeps: [reloadToken],
    dataChangedEventName: VISITOR_DATA_CHANGED_EVENT,
  });
}
